import axios from "axios";
import ErrorParser from '../../../helpers/services/error.parser';

const ObservingCapabilitiesService = {
  observingCapabilities: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/observing_capabilities",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  processtypevalues: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/observing_capabilities/pt",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  resultnaturevalues: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/observing_capabilities/rn",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  pollutants: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/observing_capabilities/p",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  concentrations: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/observing_capabilities/c",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  timesteps: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/observing_capabilities/t",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  samplingpoints: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/observing_capabilities/sp",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  processes: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/observing_capabilities/pr",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  samples: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/observing_capabilities/s",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  delete: async function (id) {
    const requestData = {
      method: "post",
      url: "/api/management/observing_capabilities/delete",
      data: { id: id }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  update: async function (observing_capabilities) {
    // debugger
    const requestData = {
      method: "post",
      url: "/api/management/observing_capabilities/update",
      data: observing_capabilities
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  import: async function (formData) {
    const requestData = {
      method: "post",
      url: "/imports/observing_capabilities",
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default ObservingCapabilitiesService;
